const routes = require('next-routes');

module.exports = routes()
	.add('/', 'index')
	.add('/search', 'search')
	.add('/es/search', 'search')
	.add('/fr/search', 'search')
	.add('/ru/search', 'search')
	.add('/archive', 'archive')
	.add('/es/archive', 'archive')
	.add('/fr/archive', 'archive')
	.add('/ru/archive', 'archive')
	.add('/affiliates', 'affiliate')
	.add('/es/filiales', 'affiliate')
	.add('/fr/filiales', 'affiliate')
	.add('/ru/chlenskie-organizacii', 'affiliate')

	.add('/:slug*', 'index');